module.exports = __webpack_public_path__ + "static/img/bcg3.ce15abaf.png";